
export default (
  {
    eventAction,
    eventCategory,
    eventLabel,
  }) => {
  return {
    event: 'SeatSelectionAncilliary',
    eventAction: eventAction,
    eventCategory: eventCategory,
    eventLabel:eventLabel,
  };
};